import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class LogoSlider {
	constructor(container) {

        const sliderEl = container.querySelector('.swiper');

        this.next = container.querySelector('[data-swiper-next]');
        this.prev = container.querySelector('[data-swiper-prev]');

        const options = {
            slidesPerView: 2,
            spaceBetween: 15,
            lazy: true,
            speed: 1000,
            keyboard: true,
            modules: [Navigation],

            breakpoints: {
				768: {
					slidesPerView: 3,
                    spaceBetween: 25,
                    centeredSlides: true,
                    loop: true,
				},
				992: {
					slidesPerView: 5,
                    spaceBetween: 25,
                    centeredSlides: false,
                    loop: false,
				},

			},

            a11y: {
                prevSlideMessage: 'Vorige slide',
                nextSlideMessage: 'Volgende slide',
            },

            navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
        };

        this.swiper = new Swiper(sliderEl, options);
	}
}
